import {
  createContext,
  PropsWithChildren,
  use,
  useEffect,
  useState,
} from 'react'
import { ClientConfigResponse, ConfigService } from '@/@types/generated'

const defaultConfig: ClientConfigResponse = {
  complaintsEnabled: false,
}

const AppConfigContext = createContext<ClientConfigResponse>(defaultConfig)

export const useAppConfig = (): ClientConfigResponse => {
  const context = use<ClientConfigResponse>(AppConfigContext)
  if (context === undefined) {
    throw new Error('useAppConfig must be used within an AppConfigContext')
  }
  return context
}

const AppConfigProvider = ({ children }: PropsWithChildren) => {
  const [config, setConfig] = useState<ClientConfigResponse>(defaultConfig)

  useEffect(() => {
    ConfigService.getClientConfig()
      .then(setConfig)
      .catch((e) => console.error('unable to load app config', e))
  }, [])

  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  )
}

export default AppConfigProvider
